import { createAction } from "@reduxjs/toolkit";
export const storeSelectedQuestionData = createAction(
  "question/storeSelectedQuestionData"
);
export const storeParentQuestionsArray = createAction(
  "question/storeParentQuestionsArray"
);
export const storeParentQuestionsArrayWithId = createAction(
  "question/storeParentQuestionsArrayWithId"
);
export const storeQuestionLanguagesForQuestion = createAction(
  "question/storeQuestionLanguagesForQuestion"
);
export const storeSelectedbucket = createAction("question/storeSelectedbucket");
export const storeBucketIdsForQuestion = createAction(
  "question/storeBucketIdsForQuestion"
);
export const storeIsEditContent = createAction("question/storeIsEditContent");
export const storeIsShow = createAction("question/storeIsShow");
export const storeScenariostate = createAction("question/storeScenariostate");
export const storeIsDirty = createAction("question/storeIsDirty");
export const storeQuestionFilter = createAction("question/storeQuestionFilter");
export const storeQuestionPagination = createAction(
  "question/storeQuestionPagination"
);
export const storeSelectedTag = createAction("question/storeSelectedTag");
export const StoreSubtypeEnabledInFilter = createAction(
  "question/StoreSubtypeEnabledInFilter"
);
export const storeComments = createAction("question/storeComments");
export const storeIsExpanded = createAction("question/storeIsExpanded");
export const storeIsQuestionCloneOpen = createAction(
  "question/storeIsQuestionCloneOpen"
);
